module.exports = __webpack_public_path__ + "static/splash-d7174bdc240cdcdedd895b6743c91af3.jpg";